export interface StepConfiguration {
	step: number;
	stepTitleKey?: string;
	titleKey: string; // < corresponds to a locale translation key
	subtitleKey?: string; // < corresponds to a locale translation key
}

const MOBILE_STEPS: StepConfiguration[] = [
	{
		step: 0,
		stepTitleKey: 'threeSteps',
		titleKey: 'aboutYou',
	},
	{
		step: 1,
		stepTitleKey: 'threeSteps',
		titleKey: 'patientInformation',
	},
	{
		step: 2,
		subtitleKey: 'clickConfirmToComplete',
		stepTitleKey: 'threeSteps',
		titleKey: 'locationDateTime',
	},
	{
		step: 3,
		subtitleKey: 'consultationScheduled',
		titleKey: 'confirmation',
	},
];

const DESKTOP_STEPS: StepConfiguration[] = [
	{
		step: 0,
		stepTitleKey: 'threeSteps',
		titleKey: 'aboutYou',
	},
	{
		step: 1,
		stepTitleKey: 'threeSteps',
		titleKey: 'patientInformation',
	},
	{
		step: 2,
		stepTitleKey: 'threeSteps',
		subtitleKey: 'clickConfirmToComplete',
		titleKey: 'locationDateTime',
	},
	{
		step: 3,
		stepTitleKey: 'allSet',
		subtitleKey: 'consultationScheduled',
		titleKey: 'confirmation',
	},
];

export function getStepConfiguration(screenSize: 'mobile' | 'desktop'): StepConfiguration[] {
	return screenSize === 'mobile' ? MOBILE_STEPS : DESKTOP_STEPS;
}
